"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PersonalMenuContent = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _LocalizationItem = require("../constants/LocalizationItem");
var _breakpoints = require("../constants/breakpoints");
var _useLogout = require("../hooks/useLogout");
var _useMenuItemsFilter = require("../hooks/useMenuItemsFilter");
var _usePersonalMenu = require("../hooks/usePersonalMenu");
var _AccordionMenu = require("./AccordionMenu");
var _FormattedMessage = require("./FormattedMessage");
var _Personalisation = require("./Personalisation");
var _SkeletonLoader = require("./SkeletonLoader");
var _jsxRuntime = require("react/jsx-runtime");
const Container = (0, _mui.styled)('div')(({
  theme
}) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  overflow: 'hidden',
  background: theme.palette.background.paper,
  boxShadow: theme.shadows[2],
  boxSizing: 'border-box',
  maxWidth: theme.spacing(66),
  backfaceVisibility: 'initial',
  transition: 'height var(--top-nav-height-animation),background-color 0.1s ease-in-out',
  zIndex: 999,
  '&::WebkitFontSmoothing': 'antialiased',
  '& a': {
    textDecoration: 'none',
    marginLeft: 0
  },
  '& button': {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: theme.spacing(10),
    border: 'none',
    fontFamily: 'SansOri, Arial, Helvetica, sans-serif',
    cursor: 'pointer',
    '&:before': {
      marginRight: theme.spacing(3),
      fontSize: '27px'
    }
  },
  [theme.breakpoints.up(_breakpoints.BREAKPOINT_HORIZONTAL_SIDEPANEL)]: {
    height: 'auto',
    position: 'fixed',
    top: 'var(--top-nav-height, 0)',
    bottom: 0,
    left: 0,
    width: theme.spacing(56),
    maxWidth: '100%',
    backfaceVisibility: 'initial',
    transition: 'unset',
    transitionProperty: 'unset',
    '& a': {
      textDecoration: 'none'
    }
  },
  '& ul': {
    margin: 0,
    padding: 0
  }
}));
const Scroller = (0, _mui.styled)('div')(({
  theme
}) => ({
  boxSizing: 'border-box',
  height: '100%',
  paddingTop: theme.spacing(3),
  overflow: 'hidden auto',
  overscrollBehavior: 'contain',
  WebkitOverflowScrolling: 'touch',
  MsOverflowStyle: '-ms-autohiding-scrollbar',
  scrollbarWidth: 'thin',
  scrollbarColor: theme.palette.grey[300],
  '&::-webkit-scrollbar': {
    width: '6px'
  },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.grey[300],
    backgroundClip: 'border-box',
    WebkitBackgroundClip: 'border-box',
    '&:hover': {
      backgroundColor: theme.palette.grey[400]
    },
    '&:active': {
      backgroundColor: theme.palette.blueGrey[200]
    },
    '&:vertical': {
      minHeight: theme.spacing(2)
    },
    '&:horizontal': {
      minWidth: theme.spacing(2)
    }
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent'
  },
  [theme.breakpoints.down(500)]: {
    '&::-webkit-scrollbar': {
      width: '3px'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.grey[300]
    }
  }
}));
const Button = (0, _mui.styled)('button')(({
  theme
}) => ({
  display: 'flex',
  flexGrow: 1,
  alignItems: 'center',
  width: '100%',
  height: theme.spacing(10),
  padding: theme.spacing(2, 3),
  overflow: 'hidden',
  background: '#f0f3f0',
  boxShadow: theme.shadows[2],
  color: theme.palette.grey[700],
  fontSize: '15px',
  fontWeight: 'bold',
  letterSpacing: theme.spacing(0.1),
  cursor: 'pointer',
  userSelect: 'none',
  margin: 0,
  '&:before': {
    marginRight: theme.spacing(3),
    fontSize: '27px'
  },
  '&:hover': {
    background: '#e8ece8',
    boxShadow: theme.shadows[4]
  }
}));
const PersonalMenuContent = () => {
  const isDesktop = (0, _mui.useMediaQuery)(({
    breakpoints
  }) => breakpoints.up(_breakpoints.BREAKPOINT_HORIZONTAL_SIDEPANEL));
  const logout = (0, _useLogout.useLogout)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const [menuClickedItem, setMenuClickedItem] = (0, _react.useState)({
    path: '',
    open: false
  });
  const {
    data
  } = (0, _usePersonalMenu.usePersonalMenu)();
  const {
    user,
    items,
    hasSubitems,
    customerTypeId
  } = data ?? {};
  const selectedPath = (0, _usePersonalMenu.useSelectedMenuItem)();
  const {
    filteredItems: menuItems,
    upgradeToConsultantUrl,
    upgradeToBrandPartnerUrl
  } = (0, _useMenuItemsFilter.useMenuItemsFilter)(items ?? [], isDesktop, customerTypeId);
  (0, _react.useEffect)(() => {
    if (selectedPath) {
      setMenuClickedItem({
        path: selectedPath,
        open: true
      });
    }
  }, [selectedPath]);
  const handleMenuClick = (0, _react.useCallback)((event, clickedItem) => {
    event.preventDefault();
    setMenuClickedItem(clickedItem);
  }, []);
  (0, _react.useEffect)(() => {
    if (hasSubitems) {
      window.ori?.vietnamELearning?.updateMenuWithVietnam();
    }
  }, [hasSubitems]);

  // This will normally be handled with suspense instead and this serves as type cheing
  if (!data) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonLoader.SkeletonLoader, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Container, {
    "data-testid": getTestId('wrapper'),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Scroller, {
      children: [!isDesktop && user ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Personalisation.Personalisation, {
        user: user,
        upgradeToConsultantUrl: upgradeToConsultantUrl,
        upgradeToBrandPartnerUrl: upgradeToBrandPartnerUrl
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionMenu.AccordionMenu, {
        menuItems: menuItems,
        menuClickedItem: menuClickedItem,
        onMenuClick: handleMenuClick
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(Button, {
      type: "button",
      "data-testid": getTestId('logout'),
      onClick: logout,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Logout, {
        sx: theme => ({
          marginRight: theme.spacing(3)
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: _LocalizationItem.LocalizationItem.SignOut
      })]
    })]
  });
};
exports.PersonalMenuContent = PersonalMenuContent;